import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs, useAttrs } from 'vue'
import { mdiRadioboxBlank, mdiRadioboxMarked } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'RadioInput',
  props: {
    modelValue: { type: [Boolean, Array, String] },
    disabled: { type: Boolean, default: false },
    color: { default: 'var(--color-blue-800)' },
    label: null,
    hideDetails: { type: [Boolean, String], default: 'auto' },
    checkedIcon: { default: mdiRadioboxMarked },
    uncheckedIcon: { default: mdiRadioboxBlank }
  },
  emits: ["update:modelValue", "input", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean | boolean[] | string | string[]): void
  (e: 'input', value: boolean | boolean[] | string | string[]): void
  (e: 'change', value: boolean | boolean[] | string | string[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean | boolean[] | string | string[], disabled: boolean, color: string, label: string, hideDetails: boolean | 'auto', checkedIcon: string, uncheckedIcon: string };





const { disabled, color, hideDetails } = toRefs(props)
const attrs = useAttrs()

const value = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val)
    emit('input', val)
    emit('change', val)
  },
})

return { __sfc: true,props, emit, disabled, color, hideDetails, attrs, value }
}

})